import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchPartLogs, searchParts } from '../../../api/partsApi';
import { PartLogsFilters } from '../../../interfaces/Parts';
import { queryKeys } from '../queryKeys';

export const usePartsSearch = (
  searchTerm: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: queryKeys.parts.search({ context: 'part-logs-select', searchTerm }),
    queryFn: () => searchParts(searchTerm || undefined, undefined, undefined, 1, 30),
    enabled,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
};

export const usePartLogs = (
  partId: string | null,
  filters: PartLogsFilters,
) => {
  return useQuery({
    queryKey: queryKeys.parts.logs({ partId, ...filters }),
    queryFn: () => fetchPartLogs(partId as string, filters),
    enabled: Boolean(partId),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
};
